(function(algolia) {
  'use strict';

  algolia.translations = {
    search: "Nykyinen haku",
    noCollectionFound: "Kategorioita ei löytynyt",
    allProducts: "Katso kaikki tuotteet",
    matching: "haulla",
    sortBy: "Lajittele:",
    relevance: "Osuvimmat",
    outOf: "joukosta",
    resultsFound: "löytyneestä hakutuloksesta",
    oneResultFound: "1 hakutulos löytyi",
    noResultFound: "Hakutuloksia ei löytynyt",
    addToCart: "Lisää ostoskoriin",
    addToCartEbook:"Osta e-kirja",
    addToCartAudiobook:"Osta äänikirja",
    addToCartDigibook:"Osta digikirja",
    preOrder: "Tilaa ennakkoon ",
    searchForProduct: "Hae kategoriasta",
    selectedFilter: "Valitut suodattimet",
    clearAll: "Poista kaikki",
    noPageFound: "Sivua ei löytynyt",
    outOfStock: "Loppu",
    unavailable: "Ei saatavilla",
    soldOut: "Loppuunmyyty",
    showVariantOptions: "Vaihtoehdot",
    goToProductPage: "Siirry tuotteen sivulle",
    searchTitle: "Hakutulokset",
    showFiltersButton: "Suodata hakutuloksia",
    filtersTitle: "Suodattimet",
    filtersInfo: "Suodata hakutuloksia klikkaamalla alta löytyviä suodattimia.",
    showResultsButton: "Suodata hakutuloksia",
    displayAsGrid: "Näytä tulokset ruudukkona.",
    displayAsList: "Näytä tulokset listana."
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Hakutuloksia ei löytynyt ' + render(text) + '';
    },

    in: function() {
      return 'ajassa ' + this.processingTimeMS / 1000  + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      var resultStr = 'Yritä {{0}} vähentää rajauksia {{1}} tai {{2}} käyttää eri hakusanaa {{3}}';
      for (var i = 0; i <= 3; i++) {
        var replace = '\{\{' + i + '\}\}';
        resultStr = resultStr.replace(replace,render(html_tags[i]));
      }
      return resultStr;
    },

    outOf: function() {
      return (
        'Hakutulokset ' +
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits)
      );
    },

    by: function(text, render) {
      return render(text) + '';
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
